import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './style.css';
export default class WindowBoxLock extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.hasVerticalScroll();
  }

  componentWillUnmount() {
    this.toggleBodyVisible('visible');
  }

  // scrollbar hidden when WindowBox show
  toggleBodyVisible(param) {
    const getBody = document.getElementsByTagName('body')[0];
    const getWinBoxs = document.getElementsByClassName('windowBoxLock__window-container');
    if (getWinBoxs.length === 1) {
      getBody.style.overflow = param;
    } else {
      document.getElementsByClassName('windowBoxLock__window-container')[1].style.overflow = 'initial';
    }
    if (param === 'hidden') {
      getBody.style.paddingRight = '16px';
    } else {
      getBody.style.paddingRight = '0px';
    }
  }

  hasVerticalScroll() {
    if (window.innerHeight) {
      if (document.body.offsetHeight > innerHeight) {
        this.toggleBodyVisible('hidden');
        return;
      }
    } else {
      if (document.documentElement.scrollHeight > document.documentElement.offsetHeight ||
      document.body.scrollHeight > document.body.offsetHeight) {
        this.toggleBodyVisible('hidden');
        return;
      }
    }
    return;
  }

  render() {
    const {
      title,
      width,
      height,
      titleBgColor,
      boxStyle,
    } = this.props;

    const style = Object.assign({}, {
      width: width ? width : 600,
      height: height ? height : 'auto',
    }, boxStyle);
    return (
      <div className="windowBoxLock__window-container">
        <div
          className="windowBoxLock__window"
          style={style}
        >
          <div className="windowBoxLock__window-title" style={{ backgroundColor: titleBgColor }}>
            <h1>{title}</h1>
          </div>
          <div className="windowBoxLock__new-window-body">
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

WindowBoxLock.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  titleBgColor: PropTypes.string,
  boxStyle: PropTypes.object,
  maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/components/WindowBoxLock/index.js
 **/